import { Guest } from '@/app/system/guest/Guest';
import axios, { AxiosInstance } from 'axios';
import { RequestPart } from '@/app/system/request/RequestPart';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';
import handleApiError from '@/shared/api/handleApiError';
import debug from 'debug';
const { CancelToken } = axios;

const localDebug = debug('AxiosRequest');

/**
 * @deprecated legacy
 */
export class AxiosRequest<T> {
  public constructor(private baseRequest: RequestPart) {}

  response(
    guest: Guest<T>,
    cancelExecutor?: (c: () => void) => void,
    actuallyCancel?: () => void,
    errorGuest?: Guest<any>,
  ): this {
    this.baseRequest.request(new GuestDynamic(value => {
      const instance = value.transportInstance as AxiosInstance;
      instance.request({
        url: value.url,
        method: value.method,
        params: value.params,
        data: value.body,
        cancelToken: cancelExecutor ? new CancelToken(cancelExecutor) : undefined,
      }).then(value => {
        guest.receive(value as T);
      })
        .catch(e => {
          guest.receive(undefined as T);
          localDebug('error happens', e);
          errorGuest?.receive(e);
          if (!axios.isCancel(e)) {
            actuallyCancel && actuallyCancel();
            handleApiError(e);
          }
        });
    }));
    return this;
  }

  introduction() {
    return 'guest' as const;
  }
}
